module.exports = __webpack_public_path__ + "static/media/dc-critical.0df97354.svg";